/**
 * inputSource.ts — Tracks the LAST input device the user actually used.
 *
 * BETA 19.68 — PSBOT cycle-30ba Bug #2: white focus box was stuck on first
 * card during PC/mouse play because the render gate used
 * `_hasGamepadConnected()` which is TRUE if any gamepad is plugged in —
 * even when the user is exclusively using mouse. The fix: gate on the
 * LAST input source the user actually used. Both mouse handlers
 * (GameCanvas.onMouseMove) and gamepad navigation (gamepadFocus.advanceFocus)
 * call `noteInputSource()` with their kind. The focus-box render in
 * engine.ts checks `getLastInputSource() === 'gamepad'`.
 *
 * This file has NO other imports to avoid circular deps (engine ↔ gamepadFocus
 * already import each other indirectly; this tracker sits orthogonal).
 */

let _lastInputSource: 'mouse' | 'gamepad' = 'mouse';

export function noteInputSource(src: 'mouse' | 'gamepad'): void {
  _lastInputSource = src;
}

export function getLastInputSource(): 'mouse' | 'gamepad' {
  return _lastInputSource;
}
